export const ageGroupLabels = { all: "All ages", "1-3": "Ages 1–3", "4-5": "Ages 4–5", "6-8": "Ages 6–8", "9-11": "Ages 9–11", "12-19": "Ages 12–19", adult: "Adults" };
export const facilityTimeZone = "America/Los_Angeles";

export function apiError(error, fallback = "Something went wrong") {
  const value = error?.response?.data?.error;
  return (typeof value === "string" ? value : value?.message) || error?.message || fallback;
}

export function time(value) { return `${new Intl.DateTimeFormat(undefined, { timeZone: facilityTimeZone, hour: "numeric", minute: "2-digit" }).format(new Date(value))} PT`; }
export function day(value) { return new Intl.DateTimeFormat(undefined, { timeZone: facilityTimeZone, weekday: "long", month: "long", day: "numeric" }).format(new Date(value)); }
export function shortDate(value) { return new Intl.DateTimeFormat(undefined, { timeZone: facilityTimeZone, month: "short", day: "2-digit" }).format(new Date(value)); }
export function dateKey(value) {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: facilityTimeZone, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date(value));
  const part = (type) => parts.find((item) => item.type === type)?.value || "";
  return `${part("year")}-${part("month")}-${part("day")}`;
}
export function duration(start, end) { return `${Math.max(1, Math.round((new Date(end) - new Date(start)) / 60000))} min`; }
export function monthFromKey(key) { const [year, month] = key.split("-").map(Number); return new Date(year, month - 1, 1); }
export function playerAgeGroup(player) {
  const born = new Date(player?.dateOfBirth); const today = new Date();
  let age = today.getFullYear() - born.getFullYear();
  if (today.getMonth() < born.getMonth() || (today.getMonth() === born.getMonth() && today.getDate() < born.getDate())) age -= 1;
  if (age <= 3) return "1-3"; if (age <= 5) return "4-5"; if (age <= 8) return "6-8"; if (age <= 11) return "9-11"; if (age <= 19) return "12-19"; return "adult";
}
